import script from "./ProfileButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileButton.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileButton.vue?vue&type=style&index=0&id=50b0a330&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b0a330"]])

export default __exports__